<div class="fixed inset-0 z-9999" (click)="closeModal()">
    <div class="absolute rounded-2xl backdrop-blur-xl bg-white/90 border border-white/40
                shadow-[0_8px_32px_rgba(0,0,0,0.15)] p-0 z-50 overflow-hidden w-64 max-h-80 overflow-y-auto"
         [ngStyle]="{ top: position.top + 'px', left: position.left + 'px' }"
         (click)="$event.stopPropagation()">
        <div class="flex flex-col divide-y divide-white/30">
            @for(task of tasks; track task.id) {
                <div class="p-3 hover:bg-white/50 transition-colors">
                    <div class="mb-1 flex justify-between items-start">
                        <p class="text-sm font-bold text-gray-800 leading-tight">{{ task.title }}</p>
                        <span class="text-xs bg-blue-500/10 text-blue-700 px-2 py-0.5 rounded-full ml-2 whitespace-nowrap font-medium">
                           @if(task.duration > 60){ {{ task.duration / 60 | number:'1.0-0' }}m}
                           @else{ {{ task.duration }}s }
                        </span>
                    </div>
                </div>
            }@empty {<div class="p-4 text-center text-xs text-gray-400">No details available</div>}
        </div>
    </div>
</div>
